import { Component, HostListener, Inject, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FileValidators } from 'ngx-file-drag-drop';
import { Subscription } from 'rxjs';
import { CampaignsService } from 'src/app/services/campaigns.service';
import { MainService } from 'src/app/services/main.service';
import Swal from 'sweetalert2';

@Component({ selector: 'app-distribution-art-file',
  templateUrl: './distribution-art-file.component.html', styleUrls: ['./distribution-art-file.component.scss'] })
export class DistributionArtFileComponent implements OnInit, OnDestroy {
  
  bodyForm : FormData = new FormData(); 
  form!: FormGroup;
  fileControl = new FormControl([],[FileValidators.uniqueFileNames, FileValidators.maxFileCount(1)]);
  strategy : any;
  progress : number = 0;
  filesSku: { nombre_archivo: string, archivo: string, id: number, user: string, created_at: string, id_rol: number, rol: string }[] = [];
  isToggleChecked: boolean = false;

  maxIntentos = 4; // 1 minuto (4 intentos de 15 segundos)
  intentos = 0;

  folder_camp: any;

  uploading = false;
  confirming = false;
  delayed = false;
  usePresignedUpload = false;
  private subscriptions = new Subscription();
  private confirmationOpen = false;
  @ViewChild('uploadProgress') private uploadProgressTemplate!: TemplateRef<any>;
  private uploadProgressDialog?: MatDialogRef<any>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data : any,
    private campaignService : CampaignsService,
    private matDialog: MatDialog,
    private main : MainService,
    private fb : FormBuilder,
    private dialogRef: MatDialogRef<DistributionArtFileComponent>,
  ) { 
    this.folder_camp = this.data.folder_camp;
    this.strategy = this.data.strategy;
   }

  ngOnInit(): void {
    this.loadForm();
    this.loadData();
    this.form = this.fb.group({ blob: [null, Validators.required] });
    this.dialogRef.disableClose = true;
    this.subscriptions.add(this.dialogRef.backdropClick().subscribe(() => this.close()));
    this.subscriptions.add(this.dialogRef.keydownEvents().subscribe(event => {
      if (event.key === 'Escape') { this.close(); }
    }));
  }

  preloadFormData(){
    this.bodyForm.append('folder_str', this.strategy.folder as string);
    this.bodyForm.append('folder_camp', this.folder_camp as string);
    this.bodyForm.append('id_str', this.strategy.id);
    this.bodyForm.append('id_sku', this.data.idSku);
    this.bodyForm.append('medida_x', this.data.medida_x);
    this.bodyForm.append('medida_y', this.data.medida_y);
    this.bodyForm.append('validaEnfocus', this.isToggleChecked == true ? '1' : '0'); 
    this.bodyForm.append('idFamily', this.data.idFamily);
    this.bodyForm.append('family', this.data.family);
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeUnload(event: BeforeUnloadEvent): void {
    if (this.uploading) { event.preventDefault(); event.returnValue = ''; }
  }

  close(): void {
    if (this.uploading) {
      Swal.fire({ icon: 'warning', title: 'Carga en curso',
        text: 'Espera a que termine la carga antes de cerrar esta ventana.' });
      return;
    }
    if (!this.confirmationOpen) { this.dialogRef.close(); }
  }

  loadForm() {
    this.form = this.fb.group({
      blob : [null, {validators:[Validators.required]}]
    });
  }

  onToggleChange(event: any) {
    this.isToggleChecked = event.checked;
  }

  saveDistributionArt(idStrategy: string) {
      this.bodyForm.append('id_str', idStrategy);
      Swal.fire({
        title: '¿Seguro que quiere subir este archivo?',
        icon: 'warning',
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: `Confirmar`,
        cancelButtonText: `Cancelar`
      }).then((result) => {
        if (result.isConfirmed) {
          if (this.form.value.blob != null && this.form.value.blob?.length != 0) {
            this.preloadFormData()
            this.bodyForm.append("blob", this.form.value.blob[0] as File);
            Swal.fire({
              icon: 'info',
              title: 'Subiendo archivo...',
              text: 'Espere un momento por favor.',
              allowEscapeKey: false,
              allowOutsideClick: false,
              showConfirmButton: false,
              didOpen: () => {
                Swal.showLoading();
              }
            });
            this.campaignService.uploadArtFile(this.bodyForm).subscribe(
              (result: any) => {
                if (result.message == 'Success') {
                  Swal.fire({
                    icon: 'success',
                    title: 'Archivo subido',
                    text: 'Archivo subido exitosamente'
                  }).then(() => {
                    this.form.reset();
                    this.dialogRef.close({ artes: true, reload: true });
                  });
                }
                else {
                  Swal.fire({
                    icon: 'error',
                    title: 'Error al guardar',
                    text: 'Ocurrió un error al guardar el archivo, por favor vuelve a intentarlo.'
                  });
                }
              },
              (err: any) => {
                this.main.HideLoading();
                Swal.fire({
                  icon: 'error',
                  title: 'Error al guardar',
                  text: 'Ocurrió un error al guardar el archivo, por favor vuelve a intentarlo.'
                });
              }
            )
  
          } else {
            Swal.fire({
              icon: 'warning',
              title: 'Error',
              html: 'El documento no ha sido adjuntado'
            });
          }
  
        }
      });
    }

  onValueChange(files : any)
  {     
    for (const item of files) {
      if(!(item.name.endsWith('.pdf')))
      {
        const index = files.indexOf(item);
  
        Swal.fire({
          icon: 'warning',
          title: 'Error',
          html: 'Solo se permiten documentos en formato .PDF'
        });
    
        if (index >= 0) {
          files.splice(index, 1); //Mantiene solo los archivos pdf en files
        }
      }
    }
  }

  loadData(){
      this.campaignService.getFilesSkuStrategy(this.strategy.id,this.data.idFamily).subscribe(
        (result:any) => {
          this.filesSku = result.data
        },
        (err:any) => {
          if(err.error.message != "No data were found in the request")
          {
            Swal.fire({
              icon: 'error',
              title: 'Error al obtener registros',
              text: 'Ocurrió un error al obtener los registros.'
            });
          }
        }
      );
    }

    onFileSelected(event: Event) {
        const input = event.target as HTMLInputElement;
        const file = input.files?.[0];
    
        if (!file) {
          return;
        }
    
        if (file.type !== 'application/pdf' && !file.name.toLowerCase().endsWith('.pdf')) {
          Swal.fire({
            icon: 'warning',
            title: 'Error',
            html: 'Solo se permiten documentos en formato .PDF'
          });
          input.value = '';
          return;
        }
    
        this.form.get('blob')?.setValue([file]);
        this.form.get('blob')?.markAsDirty();
      }

  /* async saveDistributionArt(): Promise<void> {
    // Solo para artes de distribución: cambiar a false para volver a la subida tradicional.
    const usePresignedUpload = true;
    if (this.uploading || this.confirmationOpen) { return; }
    const file: File | undefined = this.form.value.blob?.[0];
    if (!file) {
      await Swal.fire({ icon: 'warning', title: 'Error', text: 'El documento no ha sido adjuntado' });
      return;
    }
    this.confirmationOpen = true;
    const confirmation = await Swal.fire({ title: 'Con estos cambios el VoBo previo cambiará a "Pendiente"',
      icon: 'warning', showCancelButton: true, confirmButtonText: 'Confirmar', cancelButtonText: 'Cancelar' });
    this.confirmationOpen = false;
    if (!confirmation.isConfirmed) { return; }
    this.usePresignedUpload = usePresignedUpload;
    this.uploading = true;
    this.progress = 0;
    this.confirming = false;
    this.fileControl.disable();
    this.openUploadProgress();
    this.subscriptions.add(this.campaignService.uploadDistributionArtFile(file, {
      folder_str: this.data.strategy.folder, folder_camp: this.data.folder_camp,
      id_str: this.data.strategy.id
    }, usePresignedUpload).subscribe({
      next: state => {
        this.progress = state.progress;
        this.confirming = state.confirming;
        this.delayed = !!state.delayed;
        if (state.complete) {
          this.finishUpload();
          Swal.fire({ icon: 'success', title: 'Archivo cargado', text: 'Archivo cargado exitosamente' })
            .then(() => this.dialogRef.close({ reload: true }));
        }
      },
      error: () => {
        this.finishUpload();
        Swal.fire({ icon: 'error', title: 'Error al subir',
          text: 'No se pudo completar la carga. Revisa tu conexión y vuelve a intentarlo.' });
      }
    }));
  } */

  private finishUpload(): void {
    this.uploadProgressDialog?.close();
    this.uploadProgressDialog = undefined;
    this.delayed = false;
    this.uploading = false;
    this.confirming = false;
    this.fileControl.enable();
  }

  private openUploadProgress(): void {
    this.uploadProgressDialog = this.matDialog.open(this.uploadProgressTemplate, {
      width: '420px',
      maxWidth: '90vw',
      disableClose: true,
      closeOnNavigation: false,
      ariaLabel: 'Progreso de subida del archivo'
    });
    this.subscriptions.add(this.uploadProgressDialog.backdropClick().subscribe(() => this.close()));
    this.subscriptions.add(this.uploadProgressDialog.keydownEvents().subscribe(event => {
      if (event.key === 'Escape') { this.close(); }
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    this.uploadProgressDialog?.close();
  }
}
